module.exports = __webpack_public_path__ + "img/gu.e753f704.png";